// ModelCard.js
import Link from "next/link";
import Image from 'next/image';
import styles from "@/components/ui/cards/ModelCardComponent.module.css";
import PriceIndicator from "@/components/ui/cards/attributes/PriceIndicator";

const ModelCardComponent = ({evModel, range, perPage, sorting, bodyStyle, seats, price}) => {
  const {make, model, image, variant_count, min_price_category, max_price_category} = evModel;

  const encodedMake = encodeURIComponent(make);
  const encodedModel = encodeURIComponent(model);

  const cardClasses = `${styles.card} ${styles["card-bottom-left"]}`;

  let href = `/directory?make=${encodedMake}&model=${encodedModel}`;
  if (range) {
    href += `&range=${range}`;
  }
  if (perPage) {
    href += `&per_page=${perPage}`;
  }
  if (sorting) {
    href += `&sorting=${sorting}`;
  }
  if (bodyStyle) {
    href += `&body_style=${bodyStyle}`;
  }
  if (seats) {
    href += `&seats=${seats}`;
  }
  if (price) {
    href += `&price=${price}`;
  }

  // Determine the source of the image
  const hasImage = !!image;
  const imageUrl = image || '/illustrations/v2/EV-v1.png';
  const imageClassName = hasImage ? styles.cardImage : styles.fallBackImage;
  const containerClassName = hasImage ? styles.imageContainer : styles.fallbackImageContainer;

  return (
    <div className={cardClasses}>
      <Link href={href}>
        <div className={styles.cardInner}>

          <div className={containerClassName}>
            <img
              className={imageClassName}
              src={imageUrl}
              alt={`${make} ${model}`}
            />
          </div>

          <h2 className={styles.cardTitle}>{`${make} ${model}`}</h2>
          <div className={styles.attributeData}>
            <div className={styles.attributeValue}>{variant_count}</div>
            <div className={styles.attributeName}>Variants</div>
          </div>

          <div className={styles.attributeData}>
            <div className={styles.attributeValue}>
              <PriceIndicator min_price_category={min_price_category} max_price_category={max_price_category}/>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ModelCardComponent;
